export default __webpack_public_path__ + "static/SpringBoot-deb7a15144c7fcb0642353384457af19.svg";